import React from 'react';
import { ButtonFallback } from './ButtonFallback';
import { SectionFallback } from './SectionFallback';
import { PageFallback } from './PageFallback';
import { InlineFallback } from './InlineFallback';
import { FallbackType } from "@shared-types/auth.types";

export interface FallbackContentProps {
    type: FallbackType | undefined;
    title?: string;
    action: string;
    role: string;
    icon?: React.ReactNode;
}

export function FallbackContent(props: FallbackContentProps): React.ReactNode {
    const {type, ...commonProps} = props;

    switch (type) {
        case FallbackType.Button:
            return <ButtonFallback {...commonProps} />;
        case FallbackType.Section:
            return <SectionFallback {...commonProps} />;
        case FallbackType.Page:
            return <PageFallback {...commonProps} />;
        case FallbackType.Inline:
            return <InlineFallback {...commonProps} />;
        default:
            return <></>
    }
}